import React, { useEffect, useState } from 'react';

import { Pagination } from 'antd';
import Header from './header'


import style from '../scss/about.scss'



function About(){

    return (
        <>  
        <Header></Header>
            <div className="box21"></div>
            <div className="box22">
                <div className="title">
                    <h1>关于博睿</h1>
                    <span></span>
                </div>
                
                <section>
                <img src={require('../imgs/about/A.png')} alt=""/>
                <img src={require('../imgs/about/B.png')} alt=""/>
                <img src={require('../imgs/about/C.png')} alt=""/>
                </section>

            </div>
            <div className="box23">
                <div className="title">
                    <h1>成长历程</h1>
                    <span></span>
                </div> 
                <img src={require('../imgs/about/d.png')} alt=""/>

            </div>
            <div className="box24">
                  <div className="title">
                    <h1>商务理念</h1>
                    <span></span>
                </div> 
                <img src={require('../imgs/about/01.png')} alt=""/>
            </div>
            <div className="box5 box25">
            <div className="title">
                    <h1>服务过的客户</h1>
                    <span></span>
                </div>
                
                <div className="icons">
                <img src={require('../imgs/icons/01.png')} alt=""/>
                <img src={require('../imgs/icons/02.png')} alt=""/>
                <img src={require('../imgs/icons/03.png')} alt=""/>
                <img src={require('../imgs/icons/04.png')} alt=""/>
                <img src={require('../imgs/icons/05.png')} alt=""/>
                <img src={require('../imgs/icons/06.png')} alt=""/>
                <img src={require('../imgs/icons/07.png')} alt=""/>
                <img src={require('../imgs/icons/08.png')} alt=""/>
                <img src={require('../imgs/icons/09.png')} alt=""/>
                <img src={require('../imgs/icons/10.png')} alt=""/>
                <img src={require('../imgs/icons/11.png')} alt=""/>
                <img src={require('../imgs/icons/12.png')} alt=""/>
                <img src={require('../imgs/icons/13.png')} alt=""/>
                <img src={require('../imgs/icons/14.png')} alt=""/>
                <img src={require('../imgs/icons/15.png')} alt=""/>
                </div>
            </div>

        </>
    )
}




export default About